import { Dialog, DialogContent } from "@material-ui/core";
import { useContext, useState } from "react";
import TrainingContext from "../../../../context/FormacionDesarollo/TrainingContext";
import styles from "../css/ModalConfirmFinishCourse.module.css";
import { closeModalConfirmFinishCourse } from "../../../../context/FormacionDesarollo/TrainingActions";
import { useMutation } from "@apollo/client";
import {
  GET_ALL_COLLABORATORS_CURSO_BY_ID,
  GET_ALL_COLLABORATORS_CURSO_BY_ID_SEARCH,
  GET_ALL_COURSES_BY_ID,
  UPDATE_COURSE_COLLABORATOR,
} from "../../../../Querys/querys";
import { SuccessfulAlert } from "../../../../alerts/successAlerts";
import { ErrorAlert } from "../../../../alerts/errorAlert";
const ModalConfirmFinishCourse = (props: any) => {
  const { state, dispatch } = useContext(TrainingContext);
  console.log(
    "id usuario: ",
    state._id,
    ", idCurso: ",
    state._idCTP,
    ", nombre del usuario: ",
    state._bussinesName
  );
  const [activo, setActivo] = useState(false);
  const [loading, setLoading] = useState(false);
  const realId = parseInt(state._id);
  const idCTP = state._idCTP;
  const [updateStatusCourseCollaborator] = useMutation(
    UPDATE_COURSE_COLLABORATOR,
    {
      refetchQueries: [
        {
          query: GET_ALL_COURSES_BY_ID,
          variables: {
            id: idCTP,
          },
          fetchPolicy: "no-cache",
        },
        {
          query: GET_ALL_COLLABORATORS_CURSO_BY_ID,
          variables: {
            idCurso: idCTP,
          },
          fetchPolicy: "no-cache",
        },
        {
          query: GET_ALL_COLLABORATORS_CURSO_BY_ID_SEARCH,
          variables: {
            idCurso: idCTP,
            rowsOfPage: 10,
            pageNumber: 0,
            searchTerm: "",
            order: "desc",
            orderBy: "FechaIngreso",
          },
          fetchPolicy: "no-cache",
        },
      ],
    }
  );
  const handleChange = (e: any) => {
    if (e.target.value === "CONFIRMAR") {
      setActivo(true);
      setLoading(false);
    } else {
      setActivo(false);
    }
  };
  const handleSend = async (idCourse: any, idUser: any) => {
    try {
      await updateStatusCourseCollaborator({
        variables: {
          updateIdCourse: idCTP,
          updateIdUser: realId,
        },
      });
      SuccessfulAlert({ text: "El curso ha sido terminado correctamente." });
      handleClose();
      console.log("registro actualizado con exito");
    } catch (error) {
      ErrorAlert({ text: "Ocurrió un error al terminar el curso." });
      console.log(error);
    }
  };
  const handleClose = () => {
    setLoading(false);
    setActivo(false);
    closeModalConfirmFinishCourse(false, dispatch);
  };
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={state.openConfirmFinishCourse}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogContent>
        <div className={styles.contenedorPrincipal}>
          <div className={styles.contenedorCerrarModal}>
            <div
              className={styles.cerrarModal}
              onClick={() => handleClose()}
            ></div>
          </div>
          <div className={styles.contenedorPrincipal}>
            <div className={styles.fim_iconoPrincipal}>
              <div className={styles.fim_iconoComplemento}></div>
            </div>
            <div className={styles.tituloAtencion}>
              ¿Est&aacute;s seguro de que quieres terminar el curso?
            </div>
            <div className={styles.em_mensajePrtincipal}>
              Se terminar&aacute; el curso para <b>{state._bussinesName}</b>
            </div>
            <div className={styles.em_mensajePrtincipal}>
              <span className={styles.em_mensajePrtincipal}>
                {" "}
                Escribe CONFIRMAR para confirmar
              </span>
            </div>
            <div>
              <input
                className={styles.input}
                type="text"
                onChange={(e) => handleChange(e)}
              />
            </div>
          </div>
          <div className={styles.em_contenedorBotones}>
            <button
              className={styles.em_botonCancelar}
              onClick={() => handleClose()}
            >
              Cancelar
            </button>
            {activo === true ? (
              loading === true ? (
                <button
                  className={`${styles.botonesAtencion} ${styles.continuarAtencionInactivo2}`}
                >
                  <div>Confirmar</div>
                </button>
              ) : (
                <button
                  className={`${styles.botonesAtencion} ${styles.continuarAtencion}`}
                  onClick={() => handleSend(state._idCTP, realId)}
                >
                  <div>Confirmar</div>
                </button>
              )
            ) : (
              <button
                className={`${styles.botonesAtencion} ${styles.continuarAtencionInactivo}`}
              >
                <div>Confirmar</div>
              </button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default ModalConfirmFinishCourse;
